import React from 'react';
import styled from 'styled-components';
import ObsLogo from '~/components/CustomIcons/ObsLogo';

const LogoWrapper = styled.div<{ $size: number }>`
	display: flex;
	width: ${({ $size }) => $size}px;
	height: ${({ $size }) => $size}px;
	padding: 3.333px;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	border-radius: 100px;
	background: ${({ theme }) =>
		theme.tokens.COLOR_TOKENS_FILL_NON_INVERTIBLE_NEUTRAL_DARK};
`;

interface ObsLogoWrapperProps {
	size?: number;
}

const ObsLogoWrapper: React.FC<ObsLogoWrapperProps> = ({ size = 30 }) => {
	// Calculate the ObsLogo size proportionally based on the wrapper size
	// Original wrapper was 30px with logo size 23.3px
	const logoSize = (size * 23.3) / 30;

	return (
		<LogoWrapper $size={size}>
			<ObsLogo size={logoSize} />
		</LogoWrapper>
	);
};

export default ObsLogoWrapper;
